(function ($) {

	var initializeBlock = function ($block) {

		// tabs
		var tabs = $block.find('.tabs');
		tabs.each(function () {

			var container = $(this),
				control = container.find('.tabs__control-item'),
				content = container.find('.tabs__content-item'),
				active = 0;

			function updateActive(index) {
				gsap.timeline()
					.to(control, { backgroundColor: '#eff0f1', color: '#000' })
					.to(control.eq(index), { backgroundColor: '#16273d', color: '#fff' })
					.duration(0.5);

				gsap.timeline()
					.to(content, { autoAlpha: 0 })
					.to(content, { height: 0 })
					.to(content.eq(index), { height: 'auto' }, '<')
					.to(content.eq(index), { autoAlpha: 1 })
					.duration(0.5);
			}

			gsap.set(content, { height: 0 });

			updateActive(active);

			control.on("click", function () {
				updateActive($(this).index());
			});

		});

		// portfolio
		var portfolio = $block.find('.portfolio');
		portfolio.each(function () {

			var container = $(this),
				select = container.find('.portfolio__select-input'),
				label = container.find('.portfolio__select-value'),
				figure = container.find('.portfolio__chart'),
				result = container.find('.portfolio__value');

			var chart = Highcharts.chart(figure[0], {
				chart: {
					type: 'pie',
					backgroundColor: 'none'
				},
				title: {
					text: ''
				},
				colors: ['#bbd4db', '#2d4560'],
				series: [{
					data: [0, 100]
				}],
				plotOptions: {
					series: {
						enableMouseTracking: false
					}
				},
				tooltip: {
					enabled: false
				},
				legend: {
					enabled: false
				},
				credits: {
					enabled: false
				}
			});

			function updateValue() {
				var value = select.val();
				var text = select.find('option:selected').text();

				label.text(text);
				result.text(value + '%');

				chart.update({
					series: [{
						data: [Number(value), 100 - Number(value)]
					}]
				});
			}

			updateValue();

			select.change(function () {
				updateValue();
			});

		});

	}

	// Initialize each block on page load (front end).
	$(document).ready(function () {
		$('.wp-block-cms-portfolio').each(function () {
			initializeBlock($(this));
		});
	});

	// Initialize dynamic block preview (editor).
	if (window.acf) {
		window.acf.addAction('render_block_preview/type=portfolio', initializeBlock);
	}

})(jQuery);